import { keyBy } from "lodash";
import { useMemo } from "react";
import { ClusterTooltipProps, ClusterTooltip } from "react-migration/domains/map/components/ClusterTooltip";
import { useSiteStages } from "react-migration/domains/sites/hooks/useSiteStages";
import { SitesCluster } from "react-migration/domains/sites/map/SitesClusteredViewportSearchMapLayer";

export const SitesClusterTooltip = ({
  hoveredClusterInfo,
}: Pick<ClusterTooltipProps<SitesCluster>, "hoveredClusterInfo">) => {
  const { stages } = useSiteStages();

  const stageLookup = useMemo(() => {
    return keyBy(stages, "_id");
  }, [stages]);

  return (
    <ClusterTooltip
      hoveredClusterInfo={hoveredClusterInfo}
      renderTooltipContent={(hoveredClusterInfo) => (
        <>
          <h1 className="m-0 px-2.5 leading-8 text-3xs font-semibold text-text-base-tertiary uppercase cursor-default">
            Saved Sites
          </h1>
          <ul className="appearance-none overflow-y-auto shrink min-h-0">
            {hoveredClusterInfo &&
              Object.entries(hoveredClusterInfo.cluster.stage).map(([stageId, count]) => {
                const stage = stageLookup[stageId];
                const background = stage.color;

                return (
                  <li key={stageId} className="flex items-center h-7 p-1.5 gap-x-2 cursor-default">
                    <div className="w-4 h-4 rounded-sm shrink-0" style={{ background }} />
                    <span className="text-sm text-text-base-primary font-normal truncate">{stage.name}</span>
                    <div className="min-w-[18px] h-4 rounded-sm px-1 leading-4 bg-background-badge-grey text-text-base-secondary-a text-center text-xs font-medium ml-auto shrink-0">
                      {count}
                    </div>
                  </li>
                );
              })}
          </ul>
        </>
      )}
    />
  );
};
